import React from 'react'

export default function RemarkIcon(props) {
    const { width = 64, height = 64, color = '#418379' } = props;
    return (
        <svg t="1757388206989"
            className="icon"
            viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="355058"
            width={width}
            height={height}
        >
            <path d="M704 128h176c8.789333 0 16 7.210667 16 16v800a16.042667 16.042667 0 0 1-16 16H144A16.042667 16.042667 0 0 1 128 944V144C128 135.210667 135.210667 128 144 128H320V80c0-8.789333 7.210667-16 16-16h32c8.789333 0 16 7.210667 16 16V128h256V80c0-8.789333 7.210667-16 16-16h32c8.789333 0 16 7.210667 16 16V128zM336 320a16.042667 16.042667 0 0 0-16 16v32c0 8.789333 7.210667 16 16 16h352a16.042667 16.042667 0 0 0 16-16v-32a16.042667 16.042667 0 0 0-16-16h-352z m0 192a16.042667 16.042667 0 0 0-16 16v32c0 8.789333 7.210667 16 16 16h352a16.042667 16.042667 0 0 0 16-16v-32a16.042667 16.042667 0 0 0-16-16h-352z m352 192h-352a16.042667 16.042667 0 0 0-16 16v32c0 8.789333 7.210667 16 16 16h352a16.042667 16.042667 0 0 0 16-16v-32a16.042667 16.042667 0 0 0-16-16z" p-id="355059" fill={color}>
            </path>
        </svg>
    )
}
